import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { adminService } from '../../services/admin.service';
import { TenantComponentStatus, TenantActivityType } from '../../../app/app.constants';
 
@Component({
  selector: 'app-tenant-delete',   
  templateUrl: './tenant-delete.component.html',
  styleUrl: './tenant-delete.component.css'
})
export class TenantDeleteComponent implements OnInit {
  public componentStatusList : any = [];
  public tenantComponentStatus:any = TenantComponentStatus;  
  
  public statusInterval:any = null;
  public reloadTenantList:boolean = false;

  public deletionStatusText:any = null;  
  public deleteBtnDisabled:boolean = false;
  
  constructor(public dialogRef: MatDialogRef<TenantDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly adminService: adminService) { }
   
  ngOnInit(): void {
    this.getTenantCompStatus(true);

    this.adminService.delTenantSelected.subscribe((tenant:any) => {
      if(this.data.data.tenantId === tenant.tenantId) {        
        this.deletionStatusText = tenant.tenantStatus;  

        if(tenant.tenantStatus === this.tenantComponentStatus[1] || tenant.tenantStatus === this.tenantComponentStatus[2]) {
          this.deleteBtnDisabled = true;
        } else if(tenant.tenantStatus === this.tenantComponentStatus[3]) {
          this.deleteBtnDisabled = false;          
        }
        this.getTenantCompStatus(false);    
      }      
    })
  }

  getTenantCompStatus(onPopupLoad:boolean) {    
    this.adminService.getComponentStatusByTenantId(this.data.data.tenantId, TenantActivityType.DELETE).subscribe((result:any)=> {      
      this.componentStatusList = result;
      
      if(onPopupLoad) {
        const deleteSuccessCompList = this.componentStatusList.filter((comp) => comp.deleteStatus === this.tenantComponentStatus[2]);
        const deleteFailedCompList = this.componentStatusList.filter((comp) => comp.deleteStatus === this.tenantComponentStatus[3]);
        
        if(deleteFailedCompList.length > 0) {
          this.deletionStatusText = this.tenantComponentStatus[3];          
        }
        if(this.componentStatusList.length === deleteSuccessCompList.length) {
          this.deletionStatusText = this.tenantComponentStatus[2];
          this.deleteBtnDisabled = true;
          this.reloadTenantList = true;
        }
      }
    })  
  }

  /** Cancel the pop-up */
  onCancelClick(): void {
    this.dialogRef.close(this.reloadTenantList);
  }

  onDeleteClick() {
    
    this.deleteBtnDisabled = true;
    this.statusInterval = setInterval(() => {   
      this.adminService.delTenantSelected.next({tenantId: this.data.data.tenantId, tenantStatus: this.tenantComponentStatus[1]});   
      this.getTenantCompStatus(false);            
    }, 1200);

    this.adminService.deleteAdminDataByTenantId(this.data.data.tenantId).subscribe({      
      complete: () => {        
        clearInterval(this.statusInterval);              
        this.adminService.delTenantSelected.next({tenantId: this.data.data.tenantId, tenantStatus: this.tenantComponentStatus[2]});
        this.reloadTenantList = true;        
      },
      error: (error) => {          
        clearInterval(this.statusInterval);    
        this.adminService.delTenantSelected.next({tenantId: this.data.data.tenantId, tenantStatus: this.tenantComponentStatus[3]});
     },
    });
  }

}
